import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import $ from "jquery";
import "select2/dist/css/select2.css";
import "select2";

function AddCompanyInfoModal({ onClose, candidateId }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { token, setGlobalLoading } = useOutletContext();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const [companyLocations, setCompanyLocations] = useState([]);
  const [showNewLocation, setShowNewLocation] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  const company_id = watch("company_id");
  const selectedLocation = watch("company_location_id");

  // -----------------------
  // INIT SELECT2 COMPANY
  // -----------------------
useEffect(() => {
    const $select = $('[name="company_id"]');

    $select.select2({
        multiple: false,
        closeOnSelect: true,
        tags: true,
        dropdownParent: $(".addcomp"),

        createTag: function (params) {
            const term = $.trim(params.term);
            if (term === "") return null;

            console.log("CUSTOM TAG:", term);

            // ⭐ FIX: insert <option> immediately so Select2 can select it
            const newOption = new Option(term, term, true, false);
            $select.append(newOption);

            return {
                id: term,
                text: term,
                custom: true,
            };
        },

        ajax: {
            url: `${API_BASE_URL}/common_controller/get_companyinfoslist`,
            dataType: "json",
            delay: 250,
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            data: (params) => ({ search: params.term }),
            processResults: (data) => ({
                results: data.length
                    ? data.map((item) => ({
                          id: item.id,
                          text: item.name,
                          tbl: item.tbl
                      }))
                    : []
            }),
        },

        placeholder: "Search Companies",
        minimumInputLength: 2,
    });

    $select.on("select2:select", (e) => {
        const data = e.params.data;
        setValue("company_id", data.custom ? data.text : data.id);
        setCompanyId(data.tbl);
    });

    return () => {
        $select.select2("destroy");
    };

}, [token, setValue, candidateId]);


  useEffect(() => {
    if (!company_id) return;

    setGlobalLoading(true);
    axios
      .get(`${API_BASE_URL}/common_controller/companies_location/${company_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("Location data:", res.data);
        setCompanyLocations(res.data || []);
      })
      .catch(() => {
        setCompanyLocations([]);
      })
      .finally(() => setGlobalLoading(false));
  }, [company_id, token]);
  

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);

      // let finalCompanyId = data.company_id;
      // let finalLocationId = data.company_location_id;

      // if (isNaN(data.company_id)) {
      //   const body = { name: data.company_id.trim() };
      //   const res = await axios.post(
      //     `${API_BASE_URL}/common_controller/add-company`,
      //     body,
      //     { headers: { Authorization: `Bearer ${token}` } }
      //   );
      //   finalCompanyId = res.data?.id;
      // }

      // if (data.company_location_id === "others") {
      //   const payload = {
      //     companyinfo_id: finalCompanyId,
      //     location: data.location,
      //   };

      //   const locRes = await axios.post(
      //     `${API_BASE_URL}/common_controller/companies/add-location`,
      //     payload,
      //     { headers: { Authorization: `Bearer ${token}` } }
      //   );

      //   finalLocationId =
      //     locRes.data?.id ||
      //     locRes.data?.location_id ||
      //     locRes.data?.data?.id;
      // }

      // const savePayload = {
      //   candidate_id: candidateId,
      //   companyinfo_id: finalCompanyId,
      //   company_location_id: finalLocationId,
      //   designation: data.designation,
      //   start_date: data.start_date,
      //   end_date: data.end_date || null,
      //   location: data.location,
      // };

      // await axios.post(
      //   `${API_BASE_URL}/candidates/update-companyinfo`,
      //   savePayload,
      //   { headers: { Authorization: `Bearer ${token}` } }
      // );

      const finalPayload = {
  candidate_id: candidateId,
  company_id: data.company_id,
  location_id: data.company_location_id,
  designation: data.designation,
  start_date: data.start_date,
  end_date: data.end_date || null,
  location: data.location || null
};

await axios.post(
  `${API_BASE_URL}/candidates/add-full-companyinfo`,
  finalPayload,
  { headers: { Authorization: `Bearer ${token}` } }
);


      toastr.success("Company info added successfully!");
      onClose(1);
    } catch (err) {
      console.error(err);
      toastr.error("Failed to add company info");
    } finally {
      setGlobalLoading(false);
    }
  };

  return (
    <div className="modal fade show d-block addcomp" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5>Add Company Experience</h5>
            <button className="btn-close" onClick={() => onClose()}></button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                  {/* Company Select */}
              <div className="mb-3 col-md-12 col-sm-12">
                <label className="form-label">
                  Company <span className="text-danger"> * {errors.company_id && (
                  <small className="text-danger">{errors.company_id.message}</small>
                )}</span>
                </label>
                <select
                  className="form-control"
                  {...register("company_id", { required: "Required" })}
                ></select>
              </div>

              {/* Location select */}
              {companyId && (
                <div className="mb-3 col-md-12 col-sm-12">
                  {companyId === "custom" ? (
                    <>
                    <label className="form-label">
                      Location 
                      <span className="text-danger"> * 
                        {errors.location && (
                      <small>{errors.location.message}</small>
                        )}
                    </span></label>
                    <input
                    type="text"
                    className="form-control"
                    {...register("location", { required: "Required" })}
                    placeholder="Enter New Location"
                    />
                    </>
                  ):(
                    <>
                      <label className="form-label">Location 
                        <span className="text-danger"> * 
                          {errors.company_location_id && (
                            <small>{errors.company_location_id.message}</small>
                          )}
                          </span>
                          </label>
                      <select 
                        className="form-select" 
                        {...register("company_location_id", { required: "Required" })}
                            onChange={(e) => setShowNewLocation(e.target.value === "others")}
                          >
                            <option value="">Select</option>
                            {companyLocations.map((loc , index) => (
                              <option key={index} value={loc.id}>
                                {loc.location}
                              </option>
                            ))}
                            <option key={100} value="others">Others</option>
                          </select>
                    </>
                  )
                  }
                  
                </div>
              )}

              {/* Manual Location Input */}
              {showNewLocation && companyId != "custom" && (
                <div className="mb-3 col-md-12 col-sm-12">
                  <label className="form-label">
                      New Location 
                      <span className="text-danger"> * 
                        {errors.location && (
                      <small>{errors.location.message}</small>
                        )}
                    </span></label>
                    <input
                    type="text"
                    className="form-control"
                    {...register("location", { required: "Required" })}
                    placeholder="Enter New Location"
                    />
                  
                </div>
              )}

              {/* Designation */}
              <div className="mb-3 col-md-12 col-sm-12">
                <label className="form-label">Designation 
                  <span className="text-danger">
                    * {errors.designation && (
                    <small className="text-danger">{errors.designation.message}</small>
                  )}
                  </span>
                  </label>
                <input
                  type="text"
                  className="form-control"
                  {...register("designation", { required: "Required" })}
                />
              </div>

              {/* Start Date */}
              <div className="mb-3 col-md-6 col-sm-6">
                <label className="form-label">Start Date 
                  <span className="text-danger">
                    * {errors.start_date && (
                    <small className="text-danger">{errors.start_date.message}</small>
                  )}
                  </span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  {...register("start_date", { required: "Required" })}
                />
              </div>

              {/* End Date */}
              <div className="mb-3 col-md-6 col-sm-6">
                <label className="form-label">End Date</label>
                <input type="date" className="form-control" {...register("end_date")} />
              </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-light" onClick={() => onClose()}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddCompanyInfoModal;
